import React from 'react';

import { Plan, PlanDetailsCard } from '@/modules/payment';
import { plansDetailsList } from '@/modules/payment/subscription/logic';
import { IPayment } from '@/modules/payment/types';

const Plans: React.FC<{ bundles: IPayment.IBundleSchema[] }> = ({
  bundles,
}) => {
  return (
    <div className='flex flex-col'>
      <div className='ml-auto flex w-3/4 '>
        {bundles?.map((bundle, idx) => (
          <Plan key={idx} bundle={bundle} showDescription />
        ))}
      </div>
      {plansDetailsList.map((item, idx) => (
        <PlanDetailsCard
          key={idx}
          {...item}
          isLast={idx === plansDetailsList.length - 1}
          isLastIdx={idx === plansDetailsList.length - 1}
        />
      ))}
    </div>
  );
};

export { Plans };
